import React, {PropTypes} from 'react';

const circleStyle = {
  strokeDasharray: "240px, 240px",
  strokeDashoffset: "480px"
};
const pathStyle = {
  strokeDasharray:"50px, 50px",
  strokeDashoffset: "0px"
}

const Checkmark = () =>
  <span className="icon icon--order-success inlinesvg svg">
    <svg width="26px" height="26px">
      <g fill="none" stroke="#FFFFFF" stroke-width="2">
        <circle cx="13" cy="13" r="12" style={circleStyle}></circle>
        <path d="M5.817,13.778l4.93,4.909l9.444-11.393" style={pathStyle}></path>
      </g>
    </svg>
  </span>

export default Checkmark



// WEBPACK FOOTER //
// ./src/core/components/Checkmark.js